import './globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($('select').length) {
            $.fn.selectpicker.Constructor.BootstrapVersion = '4';

            // Settings
            const showCheckMark = true;

            const body = $('body');

            // Initialize single select
            $('select:not([multiple])').each(function () {
                const placeholder = $(this).data('placeholder');

                $(this).selectpicker({
                    width: '100%',
                    noneSelectedText: placeholder ? placeholder.toString() : null,
                    showTick: showCheckMark,
                    tickIcon: 'fas fa-check'
                });

                $(this).on('changed.bs.select', function () {
                    $(this).parent().find('.dropdown-menu').removeClass('d-block');
                });
            });

            // Toggle checkmark on single select options
            if (showCheckMark) {
                $(body).on('click', '.bootstrap-select', function (e) {
                    if (!$(this).prop('multiple')) {
                        if (!$(e.target).hasClass('dropdown-toggle') && !$(e.target).hasClass('filter-option-inner-inner')) {
                            const items = $(this).find('li');

                            items.removeClass('selected').removeClass('active');
                            items.find('a').removeClass('selected').removeClass('active').prop('area-selected', null);

                            $(e.target.closest('li')).addClass('selected').addClass('active');
                            $(this).find('.dropdown-menu').removeClass('d-block');
                        }
                    }
                });
            }

            // Initialize multi select
            $('select[multiple]').each(function () {
                const placeholder = $(this).data('placeholder');

                $(this).selectpicker({
                    countSelectedText: 2,
                    hideDisabled: false,
                    width: '100%',
                    showTick: showCheckMark,
                    tickIcon: 'fas fa-check',
                    noneSelectedText: placeholder ? placeholder.toString() : null
                });

                $(this).on('changed.bs.select', function () {
                    $(this).parent().find('.dropdown-menu').removeClass('d-block');
                });
            });
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
